import loadingIcon from '../assets/icons/loading.svg'

function Loading() {
  return (
    <div className='loading'><img src={loadingIcon} alt="loading icon" /></div>
  )
}

export default Loading